import { useEffect, useState } from 'react'
import { subscribeToActivity } from '../repository/activitiesRepository'
import type { Activity } from '@/types/crm'

/** Live activity log for one lead. Resubscribes when the selection changes. */
export function useActivity(leadId: string | null) {
  const [activity, setActivity] = useState<Activity[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!leadId) {
      setActivity([])
      return
    }
    setActivity([])
    return subscribeToActivity(
      leadId,
      (items) => {
        setActivity(items)
        setError(null)
      },
      (err) => setError(err.message),
    )
  }, [leadId])

  return { activity, error }
}
